<template>
<v-container fluid>
 <!-- Card -->
  <v-row>
    <v-col class="text-center">
      <v-card
      class="kontakt-card"
      tile
      elevation="16"
      >
        <v-card-title>
          <h1>Kontakt</h1>
        </v-card-title>
      </v-card>
      <!-- Contact -->
      <v-col class="pr-0 pl-0">
        <v-card
          class="big-card"
          tile
        >
          <v-row class="extra-padding-top">
          </v-row>
          <v-row class="extra-padding-bottom">
           <Form />
          </v-row>
          <v-row>
            <v-col class="contact-data">
              <p class="d-block headline">Ihr direkter vertraulicher Kontakt zu mir</p>
              <p class="d-block"><a href="tel:+4985419103079"><img src="/images/telephone-call-receiver_contact_white.svg" /><strong>+49 8541 910 30-79</strong><span>  Gerne auch nach 20 Uhr!</span></a></p>
              <p class="d-block"><a href="mailto:w.raab@raab-coaching.de"> <img src="/images/closed-envelope-email_contact_white.svg" /> w.raab@raab-coaching.de</a></p>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import Form from './Form.vue'

export default {
  components: {
    Form
  }
}
</script>

<style scoped lang="scss">
  img {
    width: 58px;
    margin: 0 auto;
    display: block;
  }

  .contact-data {
    background-color: #262F5C;
    padding-top: 3.889rem;
    padding-bottom: 3.889rem;

    p {
      color: white;
      margin-bottom: 1rem;

      &.headline {
        margin-bottom: 1.889rem;
      }

      a {
        font-size: 1.111rem;
        color: white;

        span {
          font-family: 'Barlow';
          font-weight: 400;
          font-size: 1rem;
        }
      }

      img {
        display: inline;
        max-width: 25px;
        position: relative;
        top: 4px;
        margin-right: .5rem;
      }
    }
  }

  @media screen and (max-width: 501px) {
    .contact-data{
      p {
        a {
          span {
            display: block;
          }
        }
      }
    }
  }

  .container {
    background-color: $orange-yellow;
  }

  .center-me {
    margin: 0 auto 1.22rem auto;
  }

  .border-right {
    border-right: solid 2px $orange-yellow;
  }

  .v-application {
    a {
      font-family: $second-font-family;
      font-size: 1.67rem;
      font-weight: 700;
      text-decoration: none;
      color: $orange-yellow;
    }
  }

  .v-card {
    display: inline-block;

    &.big-card {
      display: block;

      .row {
        text-align: center;
      }
    }
  }

  h1 {
    margin-left: 0;
    color: $sapphire;
  }

  p {
    color: $dark-grey-blue;
  }

  // Moving Kontakt Headline lower to overlapp with big container
  .kontakt-card {
    z-index: 10;
    position: relative;
    top: 3em;
  }

  // Extra padding to Headline
  .extra-padding-top {
    padding-top: 5.34rem;

    p {
      width: 100%;
      margin-bottom: 2em;
    }
  }

  // Extra padding bottom
  .extra-padding-bottom {
    padding-bottom: 3.9rem;
  }

  // SVG's don't have same height setting margin top on Envelop to ensure links are on same row
  .envelop {
    margin-top: 9px;
  }

  @media screen and (max-width: 959px) {
    .border-right {
      border-right: 0;
    }

    .v-application {
      a {
        font-size: 1.5rem;
        line-height: 1;
      }
    }

    .mail_link {
      font-size: 1.11rem;
    }
  }

</style>
